<template>
    <div id="index">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                    <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea"
                                @areaList="getAreaList"></areaSelect>
                    <el-form-item>
                        <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                    </el-form-item>
                </el-form>
                <template>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add"
                               v-if="judge('FactoryMonth_Create')"
                               style="margin-bottom:10px;">{{ $t('Add') }}
                    </el-button>

                    <el-table ref="multipleTable"
                              :data="tableData1"
                              v-loading="loading"
                              border
                              stripe
                              style="width:100%;min-height:200px;">
                        <el-table-column fixed="left"
                                         type="index"
                                         :label="$t('SN')"
                                         width="50">
                        </el-table-column>
                        <el-table-column prop="name"
                                         :label="$t('Campus')"
                                         width="150px">
                        </el-table-column>
                        <el-table-column prop="year"
                                         :label="$t('Year')"
                                         width="80px">
                        </el-table-column>
                        <el-table-column prop="month1"
                                         :label="$t('Jan')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month2"
                                         :label="$t('Feb')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month3"
                                         :label="$t('Mar')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month4"
                                         :label="$t('Apr')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month5"
                                         :label="$t('May')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month6"
                                         :label="$t('Jun')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month7"
                                         :label="$t('Jul')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month8"
                                         :label="$t('Aug')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month9"
                                         :label="$t('Sep')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month10"
                                         :label="$t('Oct')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month11"
                                         :label="$t('Nov')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column prop="month12"
                                         :label="$t('Dec')"
                                         min-width="80px">
                        </el-table-column>
                        <el-table-column fixed="right"
                                         :label="$t('Action')"
                                         width="150">
                            <template slot-scope="scope">
                                <el-button v-if="judge('FactoryMonth_Update')" @click="edit(scope.row)" type="primary" size="small">
                                  {{ $t('Edit') }}</el-button>
                                <template v-if="judge('FactoryMonth_Delete')">
                                    <el-popconfirm placement="top"
                                                   :confirmButtonText="$t('Delete')"
                                                   :cancelButtonText="$t('Cancel')"
                                                   @onConfirm="del(scope.row.id)"
                                                   icon="el-icon-info"
                                                   iconColor="red"
                                                   :title="$t('DeleteConfirm')">
                                        <el-button size="mini" type="danger" slot="reference"
                                                   style=" margin-left: 10px;">{{ $t('Delete') }}
                                        </el-button>
                                    </el-popconfirm>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            :page-size="10"
                            @current-change="handleCurrentChange"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>
                </template>

            </el-main>
        </el-scrollbar>
        <el-dialog :title="clickBtn=='add'? $t('Add') : $t('Update')" :visible.sync="dialogAddCarbon" width="80%" top="10vh">
            <el-form ref="Carbonform" :model="Carbonform" label-width="150px">
                <el-row :gutter="24">

                    <!--                    <el-col :span="12">-->
                    <!--                        <el-form-item label="国家">-->
                    <!--                            <el-select :placeholder="$t('el.select.placeholder')" style="width: 100%;" v-model="Carbonform.country">-->
                    <!--                                <el-option v-for="item in country"-->
                    <!--                                           :key="item.value"-->
                    <!--                                           :label="item.label"-->
                    <!--                                           :value="item.value">-->
                    <!--                                </el-option>-->
                    <!--                            </el-select>-->
                    <!--                        </el-form-item>-->
                    <!--                    </el-col>-->
                    <el-col :span="12">
                        <el-form-item :label="$t('City')">
                            <el-select v-model="Carbonform.cityId" @change="getFac('add')" :placeholder="$t('el.select.placeholder')" filterable
                                       class="queryform">
                                <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('Campus')">
                            <el-select v-model="Carbonform.factoryId" @change="getBuild('add')" :placeholder="$t('el.select.placeholder')"
                                       filterable
                                       class="queryform">
                                <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                           :label="item.label"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('Year')">
                            <el-date-picker v-model="Carbonform.year"
                                            type="year"
                                            value-format="yyyy"
                                            :placeholder="$t('ChooseYear')"
                                            style="width:150px;">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('carbonEmissions')" style="width:100%">
                            <template>
                                <el-table :data="CarbonTable1"
                                          ref="CarbonTable1"
                                          border
                                          class="formSTable"
                                          style="width: 100%;">
                                    <el-table-column prop="Jan"
                                                     :label="$t('Jan')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month1"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>

                                        </template>

                                    </el-table-column>
                                    <el-table-column prop="Feb"
                                                     :label="$t('Feb')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month2"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Mar"
                                                     :label="$t('Mar')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month3"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Apr"
                                                     :label="$t('Apr')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month4"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="May"
                                                     :label="$t('May')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month5"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="June"
                                                     :label="$t('Jun')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month6"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>

                                </el-table>
                                <el-table :data="CarbonTable2"
                                          ref="CarbonTable2"
                                          border
                                          class="formSTable"
                                          style="width: 100%;">
                                    <el-table-column prop="July"
                                                     :label="$t('Jul')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month7"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Aug"
                                                     :label="$t('Aug')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month8"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Sept"
                                                     :label="$t('Sep')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month9"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Oct"
                                                     :label="$t('Oct')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month10"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Nov"
                                                     :label="$t('Nov')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month11"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Dec"
                                                     :label="$t('Dec')"
                                                     min-width="20%">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row.month12"><i slot="suffix" style="font-style:normal;margin-right: 10px;">Ton</i></el-input>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="text-align: center ">
                        <el-button type="success" @click="onSubmit">{{ $t('Confirm') }}</el-button>
                        <el-button @click="dialogAddCarbon = false">{{ $t('Cancel') }}</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import areaSelect from '../../components/content/maintabber/areaSelect'
    import {mapState} from 'vuex';
    import {
        GetAllFactoryMonthUsageService,
        CreateFactoryMonthUsageService,
        UpdateFactoryMonthUsageService,
        DeleteFactoryMonthUsageService
    } from '../../api/api';
    import {fancha} from '../../utils/util'
    import {judgePermission} from '../../utils/util'
    export default {
        name: "carbonEmission",
        components: {
            areaSelect
        },
        data() {
            return {
                level: 2,
                deviceType: '',

                formselect: {
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: "",
                    filterText: "",
                },
                area: JSON.parse(sessionStorage.getItem("area")),
                formArea: {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""},
                facList: [],
                building: [],
                labList: [],
                deviveList: [],
                total: 0,
                loading: false,
                dialogAddCarbon: false,
                tableData1: [{
                    park: '浦东新区',
                    year: '2020',
                    Jan: '1',
                    Feb: '2',
                    Mar: '3',
                    Apr: '4',
                    May: '5',
                    June: '6',
                    July: '7',
                    Aug: '8',
                    Sept: '9',
                    Oct: '10',
                    Nov: '11',
                    Dev: '12',
                }, {}, {}],
                Carbonform: {
                    cityId: '',
                    factoryId: '',
                    year: '',
                    id: '',
                    name: ''
                },
                CarbonTable1: [{
                    month1: '',
                    month2: '',
                    month3: '',
                    month4: '',
                    month5: '',
                    month6: '',
                }],
                CarbonTable2: [{
                    month7: '',
                    month8: '',
                    month9: '',
                    month10: '',
                    month11: '',
                    month12: '',
                }],
                country: [
                    {
                        value: '1',
                        label: '中国'
                    }],
                city: [
                    {
                        value: '1',
                        label: '上海'
                    }, {
                        value: '2',
                        label: '南京'
                    }, {
                        value: '3',
                        label: '杭州'
                    }],
                pack: [
                    {
                        value: '1',
                        label: '金桥'
                    }, {
                        value: '2',
                        label: '西藏北路'
                    }],
                clickBtn: '',
                currentPage: 0,
                pageSize:10,
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            judge(e){
                return judgePermission(e)
            },
            getAreaList(e) {
                this.formselect = {...this.formselect, ...e.Valueform}
            },
            reset() {
                this.formselect = {
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: "",
                    filterText: "",
                }
                this.formArea= {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""}
                this.getData()
            },
            getFac(e) {
                var a = '', id = e == 'add' ? this.Carbonform.cityId : this.formselect.cityId
                this.area.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.facList = this.area[a].children
                this.formselect = {...this.formselect, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.Carbonform = {...this.Carbonform, ...{factoryId: ""}}
            },
            getBuild(e) {
                var a = '', id = e == 'add' ? this.Carbonform.factoryId : this.formselect.factoryId
                this.facList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.building = this.facList[a].children
                this.formselect = {...this.formselect, ...{buildingId: "", LabId: "", deviceId: ""}}
                // this.Carbonform = {...this.Carbonform, ...{buildingId: "", LabId: "", deviceId: ""}}
            },
            getLab(e) {
                var a = '', id = e == 'add' ? this.Carbonform.buildingId : this.formselect.buildingId
                this.building.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.labList = this.building[a].children
                this.formselect = {...this.formselect, ...{LabId: "", deviceId: ""}}
                // this.Carbonform = {...this.Carbonform, ...{LabId: "", deviceId: ""}}
            },
            getDevide(e) {
                var a = '', id = e == 'add' ? this.Carbonform.LabId : this.formselect.LabId
                this.labList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.deviveList = this.labList[a].children
                this.formselect = {...this.formselect, ...{deviceId: ""}}
                this.Carbonform = {...this.Carbonform, ...{deviceId: ""}}
            },
            //分页
            handleCurrentChange(val) {
                this.currentPage = (val - 1) * this.pageSize
                this.getData()
            },
            del(e) {
                var that = this
                DeleteFactoryMonthUsageService(e).then(res => {
                    if (res.success) {
                        this.$message.success(this.$t('deleteSuccessful'))
                        that.getData()
                    }
                })
            },
            add() {
                this.clickBtn = 'add'
                this.dialogAddCarbon = true
                this.Carbonform = {
                    cityId: '',
                    factoryId: '',
                    year: '',
                }
                this.CarbonTable1 = [{
                    month1: '',
                    month2: '',
                    month3: '',
                    month4: '',
                    month5: '',
                    month6: '',
                }]
                this.CarbonTable2 = [{
                    month7: '',
                    month8: '',
                    month9: '',
                    month10: '',
                    month11: '',
                    month12: '',
                }]
            },
            edit(e) {
                var data = fancha(e.regionId)
                this.Carbonform.cityId = this.area[data[0]].value
                this.facList = this.area[data[0]].children

                this.clickBtn = 'edit'
                this.dialogAddCarbon = true
                this.Carbonform.id = e.id
                this.Carbonform.factoryId = e.regionId
                this.Carbonform.name = e.name
                // this.Carbonform.year = e.year
                this.$set(this.Carbonform, 'year', JSON.stringify(e.year))
                this.CarbonTable1 = []
                this.CarbonTable2 = []
                var arr1 = [], arr2 = [], obj1 = {}, obj2 = {}
                for (var i = 1; i < 13; i++) {
                    if (i < 7) {
                        obj1['month' + i] = JSON.stringify(e['month' + i])
                    } else {
                        obj2['month' + i] = JSON.stringify(e['month' + i])
                    }
                }
                arr1.push(obj1)
                arr2.push(obj2)
                this.CarbonTable1 = arr1
                this.CarbonTable2 = arr2
            },
            getData() {
                this.loading = true
                var data = this.formselect, that = this
                data.currentPage = this.currentPage
                GetAllFactoryMonthUsageService(data).then(res => {
                    if (res.success) {
                        that.tableData1 = res.result.items
                        that.total = res.result.totalCount
                        that.loading = false
                    }
                })
            },
            onSubmit() {
                var data = {...this.CarbonTable1[0], ...this.CarbonTable2[0]}, that = this
                data.regionId = this.Carbonform.factoryId
                data.year = this.Carbonform.year
                data.id = this.Carbonform.id
                data.name = this.Carbonform.name
                if (this.clickBtn == 'edit') {
                    UpdateFactoryMonthUsageService(data).then(res => {
                        if (res.success) {
                            that.$message.success("update success")
                            that.dialogAddCarbon = false
                            that.getData()
                        } else {
                            that.$message.success("update failed")
                        }
                    })
                } else {
                    delete data.id
                    delete data.name
                    CreateFactoryMonthUsageService(data).then(res => {
                        if (res.success) {
                            that.$message.success("success")
                            that.dialogAddCarbon = false
                            that.getData()
                        } else {
                            that.$message.error("failed")
                        }
                    }).catch(err => {
                        that.$message.error(err.error.message)
                    })
                }
            },

        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>

</style>
